// Route constants to avoid magic strings throughout the application

// Define the routes type for better type inference
type RouteConfig = {
  readonly HOME: string;
  readonly NEW_CONVERSATION: string;
  readonly CONVERSATION: string;
  readonly SETTINGS: string;
  readonly ENTITY_DETAIL: string;
  readonly LOADING_DEMO: string;
  readonly FACEBOOK_DEMO: string;
  readonly REBRICKABLE_SETUP: string;
  readonly BACKOFFICE: string;
  readonly getConversationRoute: (conversationId: string) => string;
  readonly getEntityDetailRoute: (type: 'sets' | 'parts' | 'minifigs' | 'elements', id: string, colorId?: string) => string;
};

export const ROUTES = {
  HOME: '/',
  NEW_CONVERSATION: '/conversations/new',
  CONVERSATION: '/conversation/:conversationId',
  SETTINGS: '/settings',
  ENTITY_DETAIL: '/items/:type/:id',
  LOADING_DEMO: '/demo/loading',
  FACEBOOK_DEMO: '/demo/facebook-login',
  REBRICKABLE_SETUP: '/setup/rebrickable',
  BACKOFFICE: '/admin/backoffice',

  // Helper function to generate conversation route with ID
  getConversationRoute: (conversationId: string) => `/conversation/${conversationId}`,

  // Helper function to generate entity detail route
  getEntityDetailRoute: (type: 'sets' | 'parts' | 'minifigs' | 'elements', id: string, colorId?: string) =>
    `/items/${type}/${id}${colorId ? `?color=${colorId}` : ''}`
} as const satisfies RouteConfig;
